module.exports = __webpack_public_path__ + "static/img/NC.dbf94032.svg";